const ROUTE_CALLS = {
    areaCode: { name: 'Area Code', id: 'area_code' },
    zipCode: { name: 'Zip Code', id: 'zip_code' },
}

export { ROUTE_CALLS }
